exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".app-header{background-color:#87eaf2;color:#27241d;box-shadow:2px 3px 3px 2px rgba(66,61,51,.2);padding:1rem}", ""]);

